import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import BrandMark from "@/components/site/BrandMark";

const navLinks = [
  { href: "#storia", label: "Storia" },
  { href: "#sienite", label: "Sienite" },
  { href: "#localizzazione", label: "Località" },
  { href: "#contatti", label: "Contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/60 border-b border-white/[0.06]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="section-pad flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
          aria-label="GMB Graniti s.r.l. — Cava di Sienite"
        >
          <BrandMark height={44} />
          <span className="flex flex-col leading-none">
            <span className="font-display text-[0.95rem] tracking-[0.16em] uppercase text-neutral-100">
              GMB Graniti
            </span>
            <span className="font-editorial italic text-[0.7rem] text-[var(--accent)] mt-1">
              Cava di Sienite · s.r.l.
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="text-[0.78rem] tracking-[0.18em] uppercase text-neutral-400 hover:text-[var(--accent)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#contatti" data-testid="header-cta-btn" className="btn-primary hidden md:inline-flex">
          Richiedi info
        </a>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-neutral-100"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/[0.06]">
          <div className="section-pad py-8 flex flex-col gap-6">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.18em] uppercase text-neutral-300 hover:text-[var(--accent)]"
              >
                {l.label}
              </a>
            ))}
            <a href="#contatti" onClick={() => setOpen(false)} className="btn-primary w-fit">
              Richiedi info
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
